import UserEditModal from './UserEditModal';

export default UserEditModal;
